import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * Whether emails go out (GET /v1/config). Null until the server says, so a page can hold
 * back anything that promises an email (a results email, a reset link) rather than show it
 * and have it go nowhere; a failed config call stays null, which reads as "don't promise".
 */
export function useEmailEnabled(): boolean | null {
  const [enabled, setEnabled] = useState<boolean | null>(null);
  useEffect(() => {
    let live = true;
    api
      .getConfig()
      .then((c) => live && setEnabled(c.emailEnabled))
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, []);
  return enabled;
}
